module.exports = __webpack_public_path__ + "c00685314d8d24cb69fdc3e184eb4578.pdf";